<ng-container>
  <div class="custom-button">
    <p-button class="{{class}}" [pTooltip]="label === '' ? title : undefined" [icon]="icon" [iconPos]="iconPos"
      [label]="label" [size]="size" [severity]="severity" [variant]="variant" [link]="link" [disabled]="disabled"
      [style]="computedStyle" (onClick)="handleClick($event)" />
  </div>
</ng-container>